/**
 *
 * Home
 *
 */

import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { Layout } from "antd";
const { Content } = Layout;

// components
import ButtonCardIcon from "components/ButtonCardIcon";
import AddNewIconButton from "components/AddNewIconButton";

// utils
import { useAuthRole } from "utils/hooks";
import _local from "utils/localStorageUtils";

export function Home({ history, user, roles }) {
  const { t } = useTranslation();
  
  return (
    <Layout className="main-full-content">
      <Helmet>
        <title>{t("layouts.navigation.home")}</title>
        <meta name="description" content="Description of Home" />
      </Helmet>
      <Content className="main-content-container home-page">
        {!!useAuthRole(["parent"]) && (
          <AddNewIconButton
            className="float-add-communication"
            onClick={() => {
              history.push({
                pathname: `/communications/new`,
                state: {
                  from: "home",
                  goBack: "/home",
                  goBackTitle: t("layouts.navigation.home"),
                },
              });
            }}
          />
        )}

        <div className="control-btn-wrapper">
          <div className="box-btn absence">
            <h3 className="wrapper-title">{t("absences.newAbsence")}</h3>
            <div className="wrapper-btn">
              <ButtonCardIcon
                //className="medical-btn"
                icon="medical"
                title={t("global.absenceTypes.medical")}
                action={() => {
                  history.push({
                    pathname: `/absences`,
                    state: {
                      openAbsence: "medical",
                    },
                  });
                }}
              />
              <ButtonCardIcon
                //className="quill-btn"
                icon="quill"
                title={t("global.absenceTypes.no-medical")}
                action={() => {
                  history.push({
                    pathname: `/absences`,
                    state: {
                      openAbsence: "no-medical",
                    },
                  });
                }}
              />

              <ButtonCardIcon
                //className="sickness-btn"
                icon="sickness"
                title={t("global.absenceTypes.sickness")}
                action={() => {
                  history.push({
                    pathname: `/absences`,
                    state: {
                      openAbsence: "sickness",
                    },
                  });
                }}
              />
            </div>
          </div>
          <div className="box-btn quick-links">
            <h3 className="wrapper-title">{t("common.quickLinks")}</h3>
            <div className="wrapper-btn">
              {!!useAuthRole(["parent"]) && (
                <ButtonCardIcon
                  icon="absence-checked"
                  title={t("layouts.navigation.presences")}
                  action={() => {
                    history.push({
                      pathname: `/attendance`,
                    });
                  }}
                />
              )}
              <ButtonCardIcon
                icon="absence-active"
                title={t("layouts.navigation.absences")}
                action={() => {
                  history.push({
                    pathname: `/absences`,
                  });
                }}
              />

              <ButtonCardIcon
                icon="table"
                title={t("layouts.navigation.agenda")}
                action={() => {
                  history.push({
                    pathname: `/сours`,
                  });
                }}
              />

              {!!useAuthRole(["teacher"]) && (
                <ButtonCardIcon
                  icon="letter-close"
                  title={t("layouts.navigation.news")}
                  action={() => {
                    history.push({
                      pathname: `/communications`,
                    });
                  }}
                />
              )}

              {/* <ButtonCardIcon
                icon="school"
                title={t("layouts.navigation.school")}
                action={handelClick} />
              <ButtonCardIcon
                icon="parameters"
                title={t("layouts.navigation.parameters")}
                action={handelClick} />  */}
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
}

export default Home;
